import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Inject, Injectable } from "@angular/core";
import { catchError, Observable, of, retry, switchMap, throwError, timer } from "rxjs";
import { NOTYF } from "../../shared/utils/notyf.token";
import { Notyf } from "notyf";
import { IError } from "../../shared/interfaces/error.interface";
import { UserService } from "../../admin/services/user.service";
import { Router } from "@angular/router";
import { LocalStorageService } from "../../shared/services/localStorage.service";
import { AuthService } from "../services/auth.service";
import { API_CONSTANT } from "../../shared/utils/api.constant";

@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {

  constructor(
    @Inject(NOTYF) private notyf: Notyf,
    private router: Router,
    private localstorage: LocalStorageService,
    private authService: AuthService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.notyf.dismissAll();
    const userService = inject(UserService)

    return next.handle(request).pipe(
      retry({
        count: 0, delay: (errors: HttpErrorResponse, retryCount) =>
          this.shouldRetry(errors, retryCount)
      }),
      // catchError((errors: HttpErrorResponse) => {
      //   let errorMessage = "The server is not ready to process your request.";

      //   if (errors.status != 0)
      //     errorMessage = errors.error.title;

      //   if (errors.status >= 400 && errors.status <= 415)
      //     return throwError(() => this.handleFormErrors(errors.error));

      //   this.notyf.error({
      //     message: errorMessage,
      //     duration: 0
      //   });

      //   return throwError(() => new Error(errorMessage));
      // })
      catchError((errors: HttpErrorResponse) => {
        if (errors.status === 401) {
          const isRefreshRequest = request.url.includes(API_CONSTANT.REFRESH_TOKEN);
          const isLogoutRequest = request.url.includes(API_CONSTANT.LOGOUT);

          if (isRefreshRequest || isLogoutRequest) {
            this.localLogout();
            return throwError(() => errors);
          }

          // A login 401 means bad credentials or a role that is no longer allowed, not an expired
          // session: hand it straight to the sign-in screen
          if (request.url.endsWith(API_CONSTANT.LOGIN)) {
            return throwError(() => errors);
          }

          return this.authService.refreshToken().pipe(
            switchMap((res: any) => {
              const token = res.data?.accessToken || res.accessToken;
              const clonedRequest = request.clone({
                headers: request.headers.set('Authorization', 'Bearer ' + token)
              });
              return next.handle(clonedRequest);
            }),
            catchError((err) => {
              this.localLogout();
              return throwError(() => err);
            })
          )
        }
        return throwError(() => errors);
      })

    );
  }

  private shouldRetry(errors: HttpErrorResponse, retryCount: number) {
    if (errors.status == 400)
      return throwError(() => errors);

    return timer(retryCount * 1000);
  }

  private handleFormErrors(errors: IError[]) {
    let errorMessages: any = {};

    errors.forEach((err: IError) => {
      const { title, message } = err;

      if (errorMessages[title.toLowerCase()])
        errorMessages[title.toLowerCase()].push(message);
      else
        errorMessages[title.toLowerCase()] = [message];
    });

    return errorMessages;
  }

  logout(): void {
    this.authService.logout();
  }

  localLogout(): void {
    this.authService.clearTargetedStorage();
    this.router.navigate(['/auth/signin']);
  }

}
